module.exports = __webpack_public_path__ + "assets/img/22_246.06eb5943.jpg";